import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getStaffs } from "actions/teamActions";
import { getPromotionV2, addPromotionV2, editPromotionV2, deactivePromotionV2 } from "actions/promotionv2Action";
import { getShops } from "actions/shopActions";
import {  ReactTableDataGrid } from "components/Table";
import { ListDateType } from "helper/constant";
import { formatterCreateAt, convertTZ } from "components/Function";
import { ModalNewCampaign, ModalEditCampaign } from "./modal";
import Loading from "components/Loading";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

const Main = ({
    getPromotionV2,
    addPromotionV2,
    editPromotionV2,
    deactivePromotionV2,
    promotionv2,
    formatterCreateAt,
    getStaffs,
    getShops,
    shop,
    user,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [promotions_selected, setPromotionsSelected] = useState([]);
    const [edit_data, setEditData] = useState(null);
    const { t } = useTranslation();
    const { listpromotionv2, totalsize, isLoading } = promotionv2;
    const { list: shops } = shop;
    const { _id, email } = user.user;
    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalSize || 50,
        },
    ];

    useEffect(() => {
        if (Object.keys(filter).length) {
            getPromotionV2({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getPromotionV2, page, sizePerPage, searchText, filter]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            var options = [
                { value: _id, label: email },
                ...data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email + " - " + staff?.user?.name }))
            ]
            setStaffs(options);
        });
    }, [getStaffs, _id, email]);

    useEffect(() => {
        getShops({ page: 1, sizeperpage: 1000 });
    }, [getShops]);


    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);


    const columns = [
        {
            field: '_id',
            headerName: "",
            sort: false,
            editable: false,
            cellClass: "centered-cell",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => ""
        },
        {
            field: '',
            headerName: t("Actions"),
            editable: false,
            sort: true,
            width: 180,
            resizable: false,
            autoHeight: true,
            cellRenderer: ({ value: cell, data: row, rowIndex }) => (
                <>
                    <button onClick={() => { setEditData(row) }} className="btn btn-icon btn-active-color-warning btn-sm me-2 d-none" data-tooltip-id="my-tooltip" data-tooltip-content={t("Edit")} style={{ width: "calc(50% - 8px)" }}>
                        <i className="ki-outline ki-notepad-edit fs-1"></i>
                    </button>
                </>
            )
        },
        {
            field: "title",
            headerName: t("Title"),
            sort: false,
            editable: false,
        },
        {
            field: "shop",
            headerName: t("Shop"),
            sort: false,
            editable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => cell?.name
        },
        {
            field: "activity_type",
            headerName: t("Campaign Type"),
            sort: false,
            editable: false,
        },
        {
            field: "begin_time",
            headerName: t("Start Date"),
            sort: false,
            editable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => formatterCreateAt(cell),
        },
        {
            field: "end_time",
            headerName: t("End Date"),
            sort: false,
            editable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => formatterCreateAt(cell),
        },
        {
            field: "products",
            headerName: t("Products"),
            sort: false,
            editable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => cell.length,
        },
    ];

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const onSelectionChanged = (data) => {
        if (data.api) {
            const ids = data.api.getSelectedRows().map((d) => d._id);
            setPromotionsSelected(ids);
        }
    };

    const handleCreateCampaign = async (data, onClose) => {
        addPromotionV2(data, onClose);
    };

    const handleEditCampaign = async (data, onClose) => {
        editPromotionV2(data, onClose, { page, sizeperpage: sizePerPage, search: searchText, filter });
    };

    const handleDeactiveCampaign = async () => {
        deactivePromotionV2(promotions_selected, { page, sizeperpage: sizePerPage, search: searchText, filter });
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5">
                    <ModalNewCampaign shops={shops} onSubmit={handleCreateCampaign} />
                    <button onClick={() => handleDeactiveCampaign()} className="btn btn-danger btn-sm me-2">
                        {t("Deactive Campaign")}
                    </button>
                    <Select
                        isClearable
                        name="filter_shop"
                        options={shops?.map((s) => {
                            return { value: s._id.toString(), label: `${s.name} - ${s.note} - ${s.code}` }
                        })}
                        value={shops?.map((s) => {
                            return { value: s._id.toString(), label: `${s.name} - ${s.note} - ${s.code}` }
                        })?.filter(({ value }) => value === filter.shop)}
                        className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-0 al-filter-table"
                        classNamePrefix="select"
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                shop: data?.value || "",
                            }));
                            setPage(1);
                        }}
                        placeholder={t(`Select a shop ... `)}
                    />

                    <Select
                        isClearable
                        name="filter_staff"
                        options={staffs}
                        value={staffs.filter(({ value }) => value === filter.staff)}
                        className="basic-multi-select al-custom-select-search-variants mt-1 me-2 mb-0 al-filter-table"
                        classNamePrefix="select"
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                staff: data?.value || "",
                            }));
                            setPage(1);
                        }}
                        placeholder={t(`Select a staff ... `)}
                    />
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    const onTableChanged = ({ page, limit, text }) => {
        if (limit) setSizePerPage(limit);
        if (page) setPage(page);
        if (typeof text === "string") setSearchText(text);
    };

    const onFirstDataRendered = (params) => {
        params.columnApi.autoSizeColumns([
            "title", "activity_type"
        ]);
    };

    return (
        <div className="card min-w-full">
            <Loading isLoading={isLoading} />
            <div className="card-body">
                <div className="al-variants-table al-max-height-table-cus">
                    <ReactTableDataGrid
                        tableName="shopConnect"
                        idProperty="_id"
                        columns={columns}
                        rowData={listpromotionv2}
                        gridOptions={{
                            // rowHeight: 80,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={sizePerPage}
                        totalSize={totalSize}
                        onTableChanged={onTableChanged}
                        emptyText={t("No data!")}
                        rowSelection="multiple"
                        onSelectionChanged={onSelectionChanged}
                        sizePerPageList={sizePerPageList}
                        groupButton={groupButton}
                        onFirstDataRendered={onFirstDataRendered}
                    />
                </div>
                <ModalEditCampaign onSubmit={handleEditCampaign} shops={shops} edit_data={edit_data} setEditData={setEditData} />
            </div>
        </div>
    );
};

const mapStateToProps = ({ promotionv2, shop, user }) => ({ promotionv2, shop, user });
const mapDispatchToProps = {
    getPromotionV2,
    addPromotionV2,
    editPromotionV2,
    deactivePromotionV2,
    formatterCreateAt,
    getStaffs,
    getShops,
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
